<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import { cn } from "$lib/utils";
  import type { NavItem } from "./NavItems";
  import {location} from 'svelte-spa-router'

  export let items: NavItem[];
  export let isActiveLocation: (currentLocation: string, item: NavItem) => boolean;
</script>


<!-- <div
class="fixed bottom-0 w-full bg-secondary text-secondary-foreground shadow-md md:hidden"
>
<ul class="flex justify-around"> -->
<div class="flex justify-around  h-14">
  
  {#each items as item}
    <Button
      href={item.href}
      variant="tab"
      class={cn(isActiveLocation($location, item) ? "border-secondary-foreground text-foreground" : "","rounded-none h-full w-full  ")}
    >
      <div
        class="flex flex-col justify-between items-center gap-1 text-xs"
      >
        <svelte:component this={item.icon} size="18" />
        <div class="text-wrap text-center">
          {item.title}
        </div>
      </div>
    </Button>
  {/each}
</div>
<!-- </ul>
</div> -->